import { Injectable, inject } from '@angular/core'
import { RestClientList } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { environment } from '../../../../environments/environment'
import { ProductionLineRoute } from './production-line-route'

@Injectable({
  providedIn: 'root',
})
export class ProductionLineRouteService extends RestClientList<ProductionLineRoute, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger('ProductionLinePlanService')

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/production-lines/routes', http, {
      idField: 'number',
    })
  }
}
